import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { getGameImageUploadFileUrl } from '../../services'
import {
	GetUploadlFileUrlRequest,
	GetUploadFileUrlResponse,
} from '@/modules/operator/type'

interface CreateFileUrlParams {
	payload: GetUploadlFileUrlRequest
}

export default function useMutationCreateGameImageFileUrl(
	props?: UseBaseMutationOptions<GetUploadFileUrlResponse, CreateFileUrlParams>,
) {
	return useMutation({
		mutationFn: ({ payload }) => getGameImageUploadFileUrl(payload),
		...props,
	})
}
